import { defineStore } from 'pinia'
import { unref } from 'vue'

import { moneris } from '@/api'
import Route from '@/constants/route'
import Store from '@/constants/store'
import router from '@/router'

export const useMonerisStore = defineStore(Store.MONERIS, {
    state: () => ({
        success: null,
        lastErrorCode: null
    }),

    getters: {
        isSuccessful: (state) => state.success,
        errorCode: (state) => state.lastErrorCode,
        hasError: (state) => state.lastErrorCode !== null
    },

    actions: {
        async send(params) {
            try {
                const { data } = await moneris.send(unref(params))
                console.log(data)
                this.success = data.success
                
                if (data.success) {
                    // Clear error code on successful request
                    this.lastErrorCode = null
                } else {
                    // Set error code from failed response
                    this.lastErrorCode = data.error_code || data.code || 'UNKNOWN_ERROR'
                }
            } catch (error) {
                this.success = false
                
                // Get the HTTP status code from the error response
                if (error.response) {
                    // Server responded with error status
                    this.lastErrorCode = error.response.status || 
                                    error.response.data?.error_code || 
                                    error.response.data?.code || 
                                    'SERVER_ERROR'
                } else if (error.request) {
                    // Network error (no response received)
                    this.lastErrorCode = 'NETWORK_ERROR'
                } else {
                    // Something else happened
                    this.lastErrorCode = error.code || 'UNKNOWN_ERROR'
                }
            }
        },

        clearError() {
            this.lastErrorCode = null
        }
    }
})